<template>
    <div class="ribbon-root">
        <div v-if="allowed.equipmentFilter || allowed.primaryFilter || allowed.primaryValueFilter" class="ribbon-block">
            <div class="ribbon-select-block">
                <div v-if="allowed.equipmentFilter" class="ribbon-select">
                    <div class="ribbon-select-label">{{$t('Equipment')}}:</div>
                    <v-select
                            class="ribbon-select-select"
                            v-model="selectedEquipment"
                            :items="equipments"
                            item-value="id"
                            item-text="name"
                            v-on:change="updateEquipment"
                    />
                </div>
                <div v-if="allowed.primaryFilter" class="ribbon-select">
                    <div class="ribbon-select-label">{{$t('Primary Filter')}}:</div>
                    <v-select
                            class="ribbon-select-select"
                            v-model="selectedLayoutType"
                            :items="primaryFilters"
                            item-value="id"
                            item-text="name"
                            v-on:change="updateLayoutType"
                    />
                </div>
                <div v-if="allowed.primaryValueFilter" class="ribbon-select">
                    <div class="ribbon-select-label">{{$t(layoutTypes[selectedLayoutType].name)}}:</div>
                    <v-select
                            class="ribbon-select-select"
                            v-model="selectedLayoutValue"
                            :items="layoutValues"
                            item-value="id"
                            item-text="name"
                            v-on:change="updateLayoutValue"
                    />
                </div>
            </div>
        </div>
        <div v-if="showRibbonContentParameters" class="ribbon-block separator"/>
        <div v-if="showRibbonContentParameters" class="ribbon-block">
            <div class="ribbon-block-title">{{$t('Content Parameter')}}</div>
            <div class="ribbon-button-bar">
                <ribbon-button v-if="allowed.codes"             :text="$t('CEDEX Codes')"        :image="require('@/assets/icons/toolbar/codes.svg')"        @clicked="function(){navigate('Codes')}"/>
                <ribbon-button v-if="allowed.replacements"      :text="$t('CEDEX Replacement')"  :image="require('@/assets/icons/toolbar/replacements.svg')" @clicked="function(){navigate('Replacements')}"/>
                <!--<ribbon-button v-if="allowed.amendments"        :text="$t('Amendments')"         :image="require('@/assets/icons/toolbar/amendments.svg')"   @clicked="function(){navigate('Amendments')}"/>-->
                <ribbon-button v-if="allowed.tags"              :text="$t('CEDEX Tag')"          :image="require('@/assets/icons/toolbar/tag.svg')"          @clicked="function(){navigate('Tags')}"/>
                <!--
                <ribbon-button v-if="allowed.infoPopups"        :text="$t('Info Popup')"         :image="require('@/assets/icons/toolbar/infoPopup.svg')"    @clicked="function(){navigate('Info Popups')}"/>
                <ribbon-button v-if="allowed.favorites"         :text="$t('Favorite')"           :image="require('@/assets/icons/toolbar/favorite.svg')"     @clicked="function(){navigate('Favorites')}"/>
                <ribbon-button v-if="allowed.comments"          :text="$t('Comment')"            :image="require('@/assets/icons/toolbar/comment.svg')"      @clicked="function(){navigate('Comments')}"/>
                <ribbon-button v-if="allowed.defaultDimensions" :text="$t('Default Dimensions')" :image="require('@/assets/icons/toolbar/dimension.svg')"    @clicked="function(){navigate('Dimensions')}"/>
                <ribbon-button v-if="allowed.defaultQuantities" :text="$t('Default Quantity')"   :image="require('@/assets/icons/toolbar/quantity.svg')"     @clicked="function(){navigate('Quantities')}"/>
                -->
            </div>
        </div>
        <div class="ribbon-block separator"/>
        <div class="ribbon-block">
            <div class="ribbon-block-title">{{$t('View Settings')}}</div>
            <div class="ribbon-button-bar">
                <ribbon-button :text="$t('Display Columns')"  :image="require('@/assets/icons/toolbar/columns.svg')" @clicked="showColumnSelection"/>
                <div class="ribbon-button-two-state-box">
                    <ribbon-button-two-state
                        :text="$t('Code Description')"
                        :active="this.selectedCodeTexts"
                        @clicked="toggleCodeTexts"/>
                    <ribbon-button-two-state
                        v-if="allowed.allColumns"
                        :text="$t('Show Details')"
                        :active="this.detailView"
                        @clicked="toggleDetailView"/>
                </div>
            </div>
        </div>
        <div v-if="allowed.write || (allowed.csvExport && layoutType)" class="ribbon-block separator"/>
        <div v-if="allowed.write || (allowed.csvExport && layoutType)" class="ribbon-block">
            <div class="ribbon-block-title">{{$t('Actions')}}</div>
            <div class="ribbon-button-bar">
                <ribbon-button
                    v-if="allowed.write"
                    :text="$t('Save')"
                    :image="require('@/assets/icons/toolbar/save.svg')"
                    @clicked="$emit('saveDependencies')"/>
                <ribbon-button
                    v-if="allowed.csvExport && layoutType === 'surveyType'"
                    :text="$t('CSV Export')"
                    :image="require('@/assets/icons/toolbar/export.svg')"
                    @clicked="exportDependencies"/>
            </div>
        </div>
        <selector-popup
                v-if="selectorItems"
                :items="selectorItems"
                :items-preselect="selectorItemsSelected"
                :item-text="'title'"
                :item-value="'id'"
                :filter="true"
                :filter-mode="'contains'"
                :multi-select="selectorMultiSelect"
                @itemSelected="handleSelectorSelected"
        />
    </div>

</template>

<script>
    import RibbonButton from "./RibbonButton";
    import RibbonButtonTwoState from "./RibbonButtonTwoState";
    import SelectorPopup from "../SelectorPopup";
    import router from "../../router";
    import authorization from "../../plugins/authorization";

    export default {
        name: "RibbonDependencies",
        components: {SelectorPopup, RibbonButton, RibbonButtonTwoState},
        props: {
            viewMode:       String,
            codeTexts:      Boolean,
            columns:        Array,

            equipment:      String,
            equipments:     Array,
            serviceType:    String,
            serviceTypes:   Array,
            layoutType:     String,
            layoutTypes:    Object,
            layoutValue:    String,

            componentCodes: Object,
            surveyTypes:    Object,
            isoCodes:       Object
        },
        data: function() {
            return {
                detailView:          false,
                detailColumns:       ['csc', 'dppExcluded', 'iir', 'combiRepair', 'reeferMechanic', 'materialList', 'singleLine', 'flowAndTdbOnly'],
                selectedEquipment:   this.equipment,
                selectedServiceType: this.serviceType,
                selectedLayoutType:  this.layoutType,
                selectedLayoutValue: this.layoutValue,
                selectedCodeTexts:   this.codeTexts,

                selectorItems:         null,
                selectorItemsSelected: null,
                selectorMultiSelect:   null,

                allowed: {
                    read:               authorization.isAllowed('Settings/CEDEX Settings/Dependencies/Editor/View'),
                    write:              authorization.isAllowed('Settings/CEDEX Settings/Dependencies/Editor/View', authorization.write),
                    allColumns:         authorization.isAllowed('Settings/CEDEX Settings/Dependencies/Editor/All Columns'),
                    codes:              authorization.isAllowed('Settings/CEDEX Settings/Codes/View'),
                    replacements:       authorization.isAllowed('Settings/CEDEX Settings/Replacements/MERC'),
                    amendments:         authorization.isAllowed('Settings/CEDEX Settings/Amendments'),
                    tags:               authorization.isAllowed('Settings/CEDEX Settings/Tag Editor'),
                    infoPopups:         authorization.isAllowed('Settings/DPT Mobile/View'),
                    favorites:          authorization.isAllowed('Settings/DPT Mobile/View'),
                    comments:           authorization.isAllowed('Settings/DPT Mobile/View'),
                    defaultDimensions:  authorization.isAllowed('Settings/DPT Mobile/View'),
                    defaultQuantities:  authorization.isAllowed('Settings/DPT Mobile/View'),

                    equipmentFilter:    authorization.isAllowed('Settings/CEDEX Settings/Dependencies/Editor/Filter/Equipment'),
                    primaryFilter:      authorization.isAllowed('Settings/CEDEX Settings/Dependencies/Editor/Filter/Primary'),
                    primaryValueFilter: authorization.isAllowed('Settings/CEDEX Settings/Dependencies/Editor/Filter/Primary Value'),

                    csvExport:          authorization.isAllowed('Settings/CEDEX Settings/Dependencies/Editor/Export CSV'),
                }
            };
        },
        methods: {
            async updateEquipment() {
                if (await this.$confirmLeaveDialog()) {
                    this.$emit('updateView', 'equipment', this.selectedEquipment)
                } else {
                    this.selectedEquipment = this.equipment;
                }
            },
            async updateServiceType() {
                if (await this.$confirmLeaveDialog()) {
                    this.$emit('updateView', 'serviceType', this.selectedServiceType)
                } else {
                    this.selectedServiceType = this.serviceType;
                }
            },
            async updateLayoutType() {
                if (await this.$confirmLeaveDialog()) {
                    this.$emit('updateView', 'layoutType', this.selectedLayoutType)
                } else {
                    this.selectedLayoutType = this.layoutType;
                }
            },
            async updateLayoutValue() {
                if (await this.$confirmLeaveDialog()) {
                    this.$emit('updateView', 'layoutValue', this.selectedLayoutValue)
                } else {
                    this.selectedLayoutValue = this.layoutValue;
                }
            },
            setLayoutValue(layoutValue) {
                this.selectedLayoutValue = layoutValue;
            },
            showColumnSelection() {
                this.selectorItems = this.columns;
                this.selectorItemsSelected = [];
                for (let columnIndex in this.columns) {
                    if (this.columns[columnIndex].visible) {
                        this.selectorItemsSelected.push(this.columns[columnIndex].id);
                    }
                }
                this.selectorMultiSelect = true;
            },
            handleSelectorSelected(selectedColumns) {
                this.selectorItems = null;
                for (let columnIndex in this.columns) {
                    this.columns[columnIndex].visible = selectedColumns.includes(this.columns[columnIndex].id);
                }
            },
            toggleDetailView() {
                this.detailView = !this.detailView;
                this.selectedCodeTexts = !this.detailView;

                for (let index in this.detailColumns) {
                    // show/hide detail columns
                    for (let columnIndex in this.columns) {
                        if (this.columns[columnIndex].id === this.detailColumns[index]) {
                            this.columns[columnIndex].visible = this.detailView;
                        }
                    }
                }
                this.$emit('codeTexts', this.selectedCodeTexts);
            },
            toggleCodeTexts() {
                this.selectedCodeTexts = !this.selectedCodeTexts;
                this.$emit('codeTexts', this.selectedCodeTexts);
            },
            exportDependencies() {
                this.$emit('exportDependencies');
            },
            async navigate(target) {
                if (await this.$confirmLeaveDialog()) {
                    router.push({name: target});
                }
            }
        },
        computed: {
            primaryFilters() {
                let primaryFilters = [];
                for (let id in this.layoutTypes) {
                    primaryFilters.push({
                        id: id,
                        name: this.layoutTypes[id].name
                    });
                }

                return primaryFilters;
            },
            layoutValues() {
                let layoutValues = this[this.selectedLayoutType + 's'];
                layoutValues = Object.keys(layoutValues).map((function(key) {
                    return {
                        id:   key,
                        name: (this.selectedLayoutType === 'componentCode' || this.selectedLayoutType === 'isoCode' ? key + ' - ' : '') + layoutValues[key]
                    };
                }).bind(this));

                layoutValues.sort((a, b) => (a.name > b.name) ? 1 : -1);

                return layoutValues
            },
            showRibbonContentParameters() {
                return this.allowed.replacements
                    || this.allowed.amendments
                    || this.allowed.tags
                    || this.allowed.infoPopups
                    || this.allowed.favorites
                    || this.allowed.comments
                    || this.allowed.defaultDimensions
                    || this.allowed.defaultQuantities
            }
        },
        created: function() {
            this.$parent.$on('updateView', function(updateType, updateValue) {
                this['selected' + updateType.charAt(0).toUpperCase() + updateType.slice(1)] = updateValue;
            });
        }
    }
</script>

<style scoped>
    div.ribbon-root {
        text-align: left;
        height: 104px;
        background-color: var(--toolbar-background);
    }
    div.ribbon-root > div {
        display: inline-block;
    }
    div.ribbon-block {
        margin-left: 8px;
        margin-right: 8px;
        height: 104px;
        vertical-align: top;
    }
    div.ribbon-block.separator {
        background-color: var(--toolbar-separator);
        width: 1px;
        margin: 8px 0;
        height: 88px;
    }
    div.ribbon-block-title {
        font-size: 12px;
        color: var(--toolbar-label);
        text-align: center;
        padding-top: 8px;
    }
    div.ribbon-select-block {
        display: inline-block;
        padding-top: 8px;
    }
    div.ribbon-select-block:not(:last-child) {
        margin-right: 8px
    }
    div.ribbon-select {
        height: 30px;
        overflow: hidden;
    }
    div.ribbon-select > div {display: inline-block}
    div.ribbon-select-label {
        color: var(--toolbar-label);
        display: inline-block;
        width: 120px;
        font-size: 14px;
        height: 30px;
        vertical-align: top;
        line-height: 220%;
    }
    div.ribbon-button-two-state-box {
        display: inline-block;
        width: 136px;
        height: 72px;
        padding: 8px 0;
    }

</style>